export default __webpack_public_path__ + "static/media/amazonses.081a09a9.svg";